import { Component, HostListener, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { HttpClient, HttpParams } from '@angular/common/http';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CanonicalService } from 'src/app/canonical.service';
import { CountryService } from 'src/app/country.service';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.css'], animations: [
    trigger('fade',
      [
        state('void', style({ opacity: 0.5 })),
        transition(':enter', [animate(300)]),
        transition(':leave', [animate(500)]),
      ]
    )]
})
export class EducationComponent implements OnInit {
  sendAmountChanged: Subject<string> = new Subject<string>();
  receiveAmountChanged: Subject<string> = new Subject<string>();
  isMobile = false;
  country = 'sg';
  testimonialItems = [
    {
      "name_l": "JC Sekar",
      "content_l": "SingX has been a boon for my start-up AcuiZen Technologies in our cross-border transactions. Transparency in rates, fuss less methodology, speedy execution and a highly responsive support team. Could not have asked for more.",
      "name_r": "Satya Narayan",
      "content_r": "It's very easy and effortless sending money on SingX! Best exchange rate and very helpful customer service. Extremely satisfied with SingX!."
    },
    {
      // "name_l": "Sharath Waikar",
      // "content_l": "SingX has consistently provided efficient, timely and professional services with a great value for money, Switching over to SingX for all our money transfer needs was the easiest decision to make.",
      "name_l": "Lakshmikanthan Sundareswaran",
      "content_l": "Recently I have started using Singx and the experience is amazing. Its user friendly, excellent service, the best exchange rate when comparing other transfer options and same day transfer. I highly recommend Singx for money transfers to India.",
      "name_r": "Ayush Vij",
      "content_r": "I can't believe I've been paying such high FX charges every time I transfer money overseas! With SingX I know I get the best rates &amp; only pay a small fee. Its great!"
    },
    {
      "name_l": "Abhijit Kolkhede",
      "content_l": "SingX is the most transparent money transfer platform….it offers best FX rates in town along with awesome experience and ease of doing it!!",
      "name_r": "Sambasivm Arasanandan",
      "content_r": "Super easy, straight forward and the money arrived at its destination quickly! I will be using your service more often!!! Thank you SingX"
    },
    {

      "name_l": "Vineeth Kichilu",
      "content_l": "I have been using SingX from last 6 month, and I must tell you that it is one of the great remittances application I have used (I have used many over the years in many countries). What amazes me is the simplicity, transparency and speed. Good job and keep it up!. Finally, I found my perfect application, kudos to the super friendly customer support team too!"
    }
  ];

  exchange = {
    amount: '1000',
    receiveAmt: '0',
    feeType: 0,
    label: "First",
    fromId: "",
    toId: "",
    fromCountryId: "",
    toCountryId: "",
    singxFee: 0,
    exchangeRate: 0
  };
  showInverseRates = false;
  sendCurrencies = [];
  countryList = [];
  sendCurrency: any;
  receiveCurrency: any;
  sendFilterInpt = "";
  receiveFilterInpt = "";

  constructor(private meta: Meta, private title: Title, private http: HttpClient, private canonicalService: CanonicalService,
    private cs: CountryService) {
    this.title.setTitle("Money Transfer Overseas for Students Education | SingX");
    this.canonicalService.updateCanonicalUrl('/education');
    this.meta.updateTag({ name: 'description', content: 'Now it’s easy to sending money to your Childs Education in Aborad with SingX. We offer live Interbank Exchange rates with no Margins. Singx is very convenient online platform for transferring money overseas.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'Money Transfer Overseas for Students Education, International Money Transfer for Students Education, Money Transfer for Education in Abroad, Online Money Transfer to Abroad, Money Transfer Overseas for Students Education.' })
    // this.meta.addTags([
    //   { name: 'description', content: 'Now it’s easy to sending money to your Childs Education in Aborad with SingX. We offer live Interbank Exchange rates with no Margins. Singx is very convenient online platform for transferring money overseas.' },
    //   { name: 'author', content: 'SingX' },
    //   { name: 'keywords', content: 'Money Transfer Overseas for Students Education, International Money Transfer for Students Education, Money Transfer for Education in Abroad, Online Money Transfer to Abroad, Money Transfer Overseas for Students Education.' }
    // ]);
  }


  ngOnInit(): void {
    this.country = this.cs.getCountry();
    this.onResize();
    this.http.get("./assets/config.json").subscribe(resp => {
      this.sendCurrencies = resp['sendCurrencies'];
      this.countryList = resp['countryList'];
      this.sendCurrency = this.sendCurrencies[0];
      this.receiveCurrency = this.countryList[0];
      this.exchange.fromCountryId = this.sendCurrency['countryId'];
      this.exchange.toCountryId = this.receiveCurrency['countryId'];
      this.exchange.fromId = this.sendCurrency['currencyCode'];
      this.exchange.toId = this.receiveCurrency['currencyCode'];
      this.getExchangeRate();
    });

    this.sendAmountChanged.pipe(debounceTime(1000)).subscribe(sa => {
      this.exchange = {
        amount: sa,
        receiveAmt: '0',
        feeType: 0,
        label: "First",
        fromId: this.exchange.fromId,
        toId: this.exchange.toId,
        fromCountryId: this.exchange.fromCountryId,
        toCountryId: this.exchange.toCountryId,
        singxFee: 0,
        exchangeRate: 0
      };
      this.getExchangeRate();
    });

    this.receiveAmountChanged.pipe(debounceTime(1000)).subscribe(sa => {
      this.exchange = {
        amount: '0',
        receiveAmt: sa,
        feeType: 0,
        label: "Second",
        fromId: this.exchange.fromId,
        toId: this.exchange.toId,
        fromCountryId: this.exchange.fromCountryId,
        toCountryId: this.exchange.toCountryId,
        singxFee: 0,
        exchangeRate: 0
      };
      this.getExchangeRate();
    });
  }

  getExchangeRate() {
    const data = new HttpParams()
      .set('fromId', this.exchange.fromId)
      .set('toId', this.exchange.toId)
      .set('amount', this.exchange.amount + '')
      .set('receiveAmt', this.exchange.receiveAmt + '')
      .set('fromCountryId', this.exchange.fromCountryId)
      .set('toCountryId', this.exchange.toCountryId)
      .set('feeType', '0')
      .set('label', this.exchange.label);
    this.http.get("https://singx.co/singx/secure/CommonRestServiceImpl/getExchangeRates",
      { headers: { 'Content-Type': 'application/json' }, params: data }).subscribe(resp => {
        if (resp['response']['success']) {
          var data = resp['response']['data'];
          this.exchange.amount = data['amount'];
          this.exchange.receiveAmt = data['receiveamount'];
          this.exchange.singxFee = data['singxFee'];
          this.exchange.exchangeRate = data['exchangeRate'];
          this.formatDigits();
        } else {
          alert('Failed to fetch exchange rate');
        }
      })
  }

  private formatDigits() {
    //this.exchange.amount = +this.exchange.amount.toString().replace(/[^0-9-.]/g, '');
    this.exchange.amount = (+this.exchange.amount).toFixed(2);

    //this.exchange.receiveAmt = +this.exchange.receiveAmt.toString().replace(/[^0-9-.]/g, '');
    this.exchange.receiveAmt = (+this.exchange.receiveAmt).toFixed(2);
  }

  sendAmountChange($e) {
    this.sendAmountChanged.next($e);
  }

  receiveAmountChange($e) {
    this.receiveAmountChanged.next($e);
  }

  changeSendCurrency(sc) {
    this.sendCurrency = sc;
    this.exchange.fromCountryId = this.sendCurrency.countryId;
    this.exchange.fromId = this.sendCurrency.currencyCode;
    this.getExchangeRate();
  }

  changeReceiveCurrency(sc) {
    this.receiveCurrency = sc;
    this.exchange.toCountryId = this.receiveCurrency.countryId;
    this.exchange.toId = this.receiveCurrency.currencyCode;
    this.getExchangeRate();
  }

  redirectToRegistration() {
    this.cs.redirectToRegistrationPage();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    //this.screenHeight = window.innerHeight;
    this.isMobile = window.innerWidth <= 576;
  }
}
